export default "__VITE_ASSET__BkBOUyhA__"